import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2d38b9f3&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=2d38b9f3&prod&scoped=true&lang=css"
import style1 from "./Footer.vue?vue&type=style&index=1&id=2d38b9f3&prod&lang=css"
import style2 from "./Footer.vue?vue&type=style&index=2&id=2d38b9f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38b9f3",
  null
  
)

export default component.exports